import React from 'react'
import { Chip } from '@mui/material'
import {
  CheckCircle as GoodIcon,
  Warning as WatchIcon,
  Error as PoorIcon,
  Cancel as CriticalIcon,
  Schedule as PendingIcon,
} from '@mui/icons-material'

import type { HealthStatus } from '../../../types/healthCheck'
import { BAND_HEX, type SeverityBand } from '../../../utils/exceptionSeverity'

interface HealthStatusBadgeProps {
  status: HealthStatus
  size?: 'small' | 'medium'
}

const STATUS_TO_BAND: Record<HealthStatus, SeverityBand> = {
  good: 'Good',
  watch: 'Watch',
  poor: 'Poor',
  critical: 'Critical',
  pending: 'Not Configured',
}

const LABEL: Record<HealthStatus, string> = {
  good: 'Good',
  watch: 'Watch',
  poor: 'Poor',
  critical: 'Critical',
  pending: 'Coming soon',
}

const ICON: Record<HealthStatus, React.ReactElement> = {
  good: <GoodIcon fontSize="small" />,
  watch: <WatchIcon fontSize="small" />,
  poor: <PoorIcon fontSize="small" />,
  critical: <CriticalIcon fontSize="small" />,
  pending: <PendingIcon fontSize="small" />,
}

export const HealthStatusBadge: React.FC<HealthStatusBadgeProps> = ({ status, size = 'small' }) => {
  const bg = BAND_HEX[STATUS_TO_BAND[status] ?? 'Not Configured']
  const isPending = status === 'pending'

  return (
    <Chip
      label={LABEL[status] ?? 'Coming soon'}
      icon={ICON[status] ?? ICON.pending}
      size={size}
      variant={isPending ? 'outlined' : 'filled'}
      sx={{
        bgcolor: isPending ? 'transparent' : bg,
        color: isPending ? 'text.secondary' : '#ffffff',
        borderColor: isPending ? bg : 'transparent',
        '& .MuiChip-icon': {
          color: isPending ? 'text.secondary' : '#ffffff',
        },
      }}
    />
  )
}

export default HealthStatusBadge
